// Danske tekster til statistiksiden (fase 3). Ordlyd følger
// docs/concept/fase3-statistik.html og docs/prototype/index.html.
const texts = {
  title: 'Statistik',
  needClubTitle: 'Statistik kræver en klub',
  needClubHint: 'Opret eller bliv medlem af en klub, så samler vi jeres meldinger, makkerskaber og rekorder her.',
  needClubLink: 'Gå til klubber →',
  clubLabel: 'Klub',
  yearLabel: 'Sæson',
  noGamesInYear: (year: number) => `Ingen afsluttede spil i ${year} endnu`,
  modeSeason: 'Sæson',
  modeGame: 'Spil',
  curveTitle: 'Pointkurve',
  curveSubtitle: (name: string) => `${name} · stilling efter runder`,
  curveEmpty: 'Ingen runder spillet endnu',
  curveNoGame: 'Ingen spil i klubben endnu',
  curveNeedTwoRounds: 'Ingen spil med mindst to runder endnu',
  gameListEmpty: 'Ingen spil i klubben endnu',
  statusActive: 'Aktiv',
  statusCompleted: 'Afsluttet',
  gameStandingTitle: 'Stilling',
  playersTableTitle: 'Spillere',
  playersColName: 'Navn',
  playersColBids: 'Meldinger',
  playersColWon: 'Gået hjem',
  playersColPartner: 'Som makker',
  playersColSolo: 'Sole',
  standingTitle: 'Sæsonstilling',
  standingRank: '#',
  standingName: 'Spiller',
  standingPoints: 'Point',
  standingGames: 'Spil',
  standingWins: 'Sejre',
  bidsTitle: 'Meldinger',
  bidsTotal: (total: number) => `${total} meldinger i alt`,
  bidsEmpty: 'Ingen meldinger endnu',
  bidCountLabel: (count: number) => `${count}`,
  bidderPartnersTitle: 'Makkerskaber',
  bidderPartnersHint: 'Melder lodret, makker vandret. Tallet er antal runder.',
  bidderPartnersEmpty: 'Ingen makkerskaber endnu',
  partnersTitle: 'Makkere',
  partnersHint: 'Point og vundne runder (x/y), når de to var makkere. Point vundet som modstandere tæller ikke med her.',
  partnersEmpty: 'Ingen makkerskaber endnu',
  trumpsTitle: 'Trumf',
  trumpValueLabel: (count: number, winRate: number) => (count === 0 ? '0' : `${count} · ${Math.round(winRate * 100)} % gået hjem`),
  recordsTitle: 'Rekorder',
  recordBiggestRound: 'Største enkeltrunde',
  recordLongestNight: 'Længste aften',
  recordBestNight: 'Bedste aften',
  recordMostSolos: 'Flest sole',
  recordsEmpty: 'Ingen rekorder endnu',
  roundsSuffix: (n: number) => `${n} runder`,
  profileTitle: 'Din profil',
  profileGames: 'Aftener',
  profileRounds: 'Runder',
  profileTotalPoints: 'Point i alt',
  profileAsBidder: 'Gevinst som melder',
  profileAsPartner: 'Gevinst som makker',
  profileAsOpponent: 'Gevinst som modstander',
  profileSolos: 'Sole',
  profileFavoriteBid: 'Favoritmelding',
  profileFavoriteTrump: 'Favorittrumf',
  profileBestPartner: 'Bedste makker',
  profileBestNight: 'Bedste aften',
  profileEmptyBestPartner: 'Ingen makkerskaber endnu',
  profileEmptyBestNight: 'Ingen afsluttede aftener endnu',
  profileNeedGames: 'Spil nogle runder, så samler vi din profil her',
  none: '–',
  wonOf: (won: number, count: number) => `${won} af ${count}`,
  legendMint: 'Går godt',
  legendGold: 'Middel',
  legendRed: 'Går skidt',
  matrixEmptyCell: '·',
  loading: 'Henter statistik…',
  couldNotLoad: 'Kunne ikke hente statistikken'
}

export default texts
